// Small, consistent badge showing how many points a Location or a Mission
// awards to whoever wins it. Used in the location banner, the dropzone mission
// slots and on mission cards so the 1-vs-2 point value is always legible.
// 1 point → subtle outlined badge; 2 points → bright gold, highlighted.
interface PointsBadgeProps {
  value: number;
}

export function PointsBadge({ value }: PointsBadgeProps) {
  const hi = value >= 2;
  return (
    <span
      className={`points-badge${hi ? ' points-badge-hi' : ''}`}
      title={`Worth ${value} point${value === 1 ? '' : 's'} to whoever wins it`}
    >
      {value} {value === 1 ? 'PT' : 'PTS'}
    </span>
  );
}
